import { GroupSecurity } from '@quromedical/fhir-common';
import type { PatientRouteParams } from 'app/routes';
import { PatientHeaderSection } from 'core/patient';
import { Tabs } from 'design-system';
import { useGlobalSearchParams } from 'expo-router';
import { useUserSession } from 'hooks';
import type React from 'react';
import { useCallback, useRef } from 'react';
import { ScrollView } from 'react-native';
import { strings } from 'strings';

import { PatientVitalsActiveTab } from './PatientVitalsActiveTab';
import { PatientVitalsTrackingTab } from './PatientVitalsTrackingTab';

export const PatientVitalsScreen: React.FC = () => {
  const session = useUserSession();

  const { patientId } = useGlobalSearchParams<PatientRouteParams>();
  const scrollViewRef = useRef<ScrollView | null>(null);

  const scrollToTop = useCallback(() => {
    scrollViewRef.current?.scrollTo(0);
  }, []);

  const hasTrackingPermission = session.hasAny([
    GroupSecurity.FeaturePreviewTracking,
  ]);

  return (
    <ScrollView ref={scrollViewRef}>
      <PatientHeaderSection id={patientId} />

      <Tabs.Group>
        <Tabs.Screen title={strings.VitalsActiveTabTitle}>
          <PatientVitalsActiveTab id={patientId} scrollToTop={scrollToTop} />
        </Tabs.Screen>
        <Tabs.Screen
          title={strings.VitalsTrackingTabTitle}
          isHidden={!hasTrackingPermission}
        >
          <PatientVitalsTrackingTab id={patientId} scrollToTop={scrollToTop} />
        </Tabs.Screen>
      </Tabs.Group>
    </ScrollView>
  );
};
